import { render } from "./FavoriteBinanceAlpha.vue?vue&type=template&id=43cfabcc"
import script from "./FavoriteBinanceAlpha.vue?vue&type=script&lang=js"
export * from "./FavoriteBinanceAlpha.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__